import {setPassengerDataUpdating} from "@CheckOrder/reducers/checkOrderSlice";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";
import useUpdatePassengers from "@CheckOrder/hooks/useUpdatePassengers";
import {useLazyUpdateAmenitiesQuery} from "@CheckOrder/api/checkOrderApi";
import {GeneralAmenitySelectedType} from "@CheckOrder/features/amenities/types/GeneralAmenitySelected.type";

/**
 * Returns function used for dispatching update passengers and update amenities request.
 */
export default function useUpdateAmenitiesQuery() {
    const {
        passengers,
        ticket: {
            ticketCode,
        },
    } = useAppSelector((state) => (state?.checkOrder))

    const dispatch = useAppDispatch()

    const {updateAllPassengersAndVerifySubmission} = useUpdatePassengers()
    const [query, response] = useLazyUpdateAmenitiesQuery()
    const updateAmenities = async (
        singleSelectedAmenities: Record<string, GeneralAmenitySelectedType>,
        returnSelectedAmenities: Record<string, GeneralAmenitySelectedType>
    ) => {
        dispatch(setPassengerDataUpdating(true))
        await updateAllPassengersAndVerifySubmission()
        query({
            passengers,
            singleAmenities: singleSelectedAmenities,
            returnAmenities: returnSelectedAmenities,
            ticketCode,
        })
    }

    return {
        updateAmenities,
        response,
    }
}